import { FC, ReactNode } from 'react'
import CloseIcon from '@mui/icons-material/Close'

import { ThemeButton } from '../../buttons'
import {
  ModalOverlay,
  ModalContainer,
  ModalHeader,
  ModalTitleRow,
  ModalTitleWrapper,
  ModalTitle,
  CloseButton,
  ModalDescription,
  ModalContent,
  ModalActions
} from './onyxiaBasicModal.styles'

interface OnyxiaBasicModalProps {
  isOpen: boolean
  title: string
  description?: ReactNode
  children?: ReactNode
  submitButtonText: string
  cancelButtonText: string
  onSubmit: () => void
  onCancel: () => void
  submitDisabled?: boolean
}

const OnyxiaBasicModal: FC<OnyxiaBasicModalProps> = ({
  isOpen,
  title,
  description,
  children,
  submitButtonText,
  cancelButtonText,
  onSubmit,
  onCancel,
  submitDisabled = false
}) => {
  if (!isOpen) return null

  const handleOverlayClick = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) {
      onCancel()
    }
  }

  return (
    <ModalOverlay onClick={handleOverlayClick}>
      <ModalContainer>
        <ModalContent>
          <ModalHeader>
            <ModalTitleRow>
              <ModalTitleWrapper>
                <ModalTitle>{title}</ModalTitle>
              </ModalTitleWrapper>
              <CloseButton onClick={onCancel}>
                <CloseIcon sx={{ fontSize: 24 }} />
              </CloseButton>
            </ModalTitleRow>
            {description && <ModalDescription>{description}</ModalDescription>}
          </ModalHeader>
          {children}
        </ModalContent>

        <ModalActions>
          <ThemeButton themevariant="secondary" shape="rectangular" onClick={onCancel} sx={{ flex: 1 }}>
            <>{cancelButtonText}</>
          </ThemeButton>
          <ThemeButton
            themevariant="primary"
            shape="rectangular"
            onClick={onSubmit}
            disabled={submitDisabled}
            sx={{ flex: 1 }}
          >
            <>{submitButtonText}</>
          </ThemeButton>
        </ModalActions>
      </ModalContainer>
    </ModalOverlay>
  )
}

export default OnyxiaBasicModal
